import React, { useState } from 'react';
const modules = [{
  id: 1,
  name: 'Positioning',
  full: 'Authority & Personal Brand Positioning',
  description: 'Define your unique voice and position in your industry'
}, {
  id: 2,
  name: 'Content Strategy',
  full: 'Content Strategy & Platform Alignment',
  description: 'Match your content to the right platforms for maximum impact'
}, {
  id: 3,
  name: 'AI Operations',
  full: 'AI-Powered, Humanized Content Creation',
  description: 'Leverage AI while maintaining your authentic voice and building your content machine'
}, {
  id: 4,
  name: 'Idea Generation',
  full: 'Content Machines & Idea Generation',
  description: 'Build systems that generate endless content ideas through your custom framework'
}, {
  id: 5,
  name: 'Consistency',
  full: 'Consistency Systems & Sustainable Habits',
  description: 'Create workflows that make consistency effortless'
}, {
  id: 6,
  name: 'Accountability',
  full: 'Accountability Pods & Peer Pressure',
  description: 'Small groups that keep you on track through structured pressure'
}, {
  id: 7,
  name: 'Community Growth',
  full: 'Community-Driven Engagement Growth',
  description: 'Grow your audience through strategic community building'
}, {
  id: 8,
  name: 'Narrative Craft',
  full: 'Thought Leadership & Narrative Craft',
  description: 'Develop compelling narratives that establish authority'
}, {
  id: 9,
  name: 'Monetization',
  full: 'Monetization Pathways & Opportunity Leverage',
  description: 'Turn authority into revenue streams'
}, {
  id: 10,
  name: 'Analytics',
  full: 'Feedback, Analytics & Long-Term Sustainability',
  description: 'Measure, optimize, and sustain your authority engine'
}];
export function SystemModulesInteractive() {
  const [activeModule, setActiveModule] = useState<number | null>(null);
  return <section id="system" className="py-24 border-b border-dashed border-[#9ca3af] bg-[#f5f5f7]" data-id="element-88">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-89">
        <div className="text-center mb-16" data-id="element-90">
          <h2 className="font-mono text-xs font-bold text-salon-red mb-2" data-id="element-91">
            04_ARCHITECTURE
          </h2>
          <h3 className="text-3xl font-bold text-[#1f2933]" data-id="element-92">System Modules</h3>
          <p className="mt-4 font-mono text-sm text-[#9ca3af]" data-id="element-93">
            Click or hover to explore each module
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-5 gap-4" data-id="element-94">
          {modules.map(module => <div key={module.id} className="relative border border-[#1f2933] p-4 hover:bg-salon-red hover:text-white transition-all duration-300 group cursor-pointer" onMouseEnter={() => setActiveModule(module.id)} onMouseLeave={() => setActiveModule(null)} onClick={() => setActiveModule(activeModule === module.id ? null : module.id)} data-id="element-95">
              <span className="font-mono text-[10px] text-[#9ca3af] group-hover:text-white/70 block mb-2" data-id="element-96">
                MOD_{String(module.id).padStart(2, '0')}
              </span>
              <span className="font-bold text-sm block mb-2" data-id="element-97">
                {module.name}
              </span>

              {/* Desktop hover/click description */}
              <div className={`hidden md:block absolute left-0 right-0 top-full mt-2 bg-white border-2 border-salon-red p-4 shadow-lg z-10 transition-all duration-300 ${activeModule === module.id ? 'opacity-100 visible' : 'opacity-0 invisible'}`} data-id="element-98">
                <h4 className="font-bold text-sm text-[#1f2933] mb-2" data-id="element-99">
                  {module.full}
                </h4>
                <p className="font-mono text-xs text-[#1f2933]/80" data-id="element-100">
                  {module.description}
                </p>
              </div>

              {/* Mobile description (always visible when active) */}
              <div className={`md:hidden transition-all duration-300 overflow-hidden ${activeModule === module.id ? 'max-h-40 mt-3' : 'max-h-0'}`} data-id="element-101">
                <p className="font-mono text-[10px] text-[#1f2933] group-hover:text-white/90" data-id="element-102">
                  {module.description}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}